import { memo } from 'react';
import { useNodeConnections } from '@xyflow/react';
import { CodePrimitive } from './primitive';
import { CodeTransform } from './transform';
import { areNodePropsEqual } from '../are-node-props-equal';
import i18next from '@/lib/i18n';

const t = (k: string): string => String(i18next.t(k));

export type CodeNodeProps = {
  type: string;
  data: {
    generated?: {
      text?: string;
      language?: string;
    };
    model?: string;
    updatedAt?: string;
    instructions?: string;
    content?: {
      text?: string;
      language?: string;
    };
  };
  id: string;
};

export const CodeNode = memo((props: CodeNodeProps) => {
  const connections = useNodeConnections({
    id: props.id,
    handleType: 'target',
  });
  const Component = connections.length ? CodeTransform : CodePrimitive;

  return <Component {...props} title={t("Code")} />;
}, areNodePropsEqual);
CodeNode.displayName = 'CodeNode';
